<template>
  <div class="page">
    <BACK title="變更密碼"/>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="舊密碼" prop="oldPassword">
        <el-input v-model="form.oldPassword" oninput="value=value.replace(value.slice(14),'')" type="password" clearable placeholder="輸入舊密碼"></el-input>
      </el-form-item>
      <el-form-item label="新密碼" prop="password">
        <el-input v-model="form.password" oninput="value=value.replace(value.slice(14),'')" type="password" clearable placeholder="輸入新密碼"></el-input>
      </el-form-item>
      <el-form-item label="確認密碼" prop="password2">
        <el-input v-model="form.password2" oninput="value=value.replace(value.slice(14),'')" type="password" clearable placeholder="再次輸入密碼"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn">
      <el-button type="success" :disabled="loading" @click="handleSubmit()"><i class="el-icon-loading" v-if="loading"></i>送出</el-button>
    </div>
  </div>
</template>
<script>

import BACK from '@/components/back.vue'
import FN from '@/components/fn'
import { mapActions } from 'vuex'

export default {
  name: 'ChangePassword',
  components: {
    BACK
  },
  mixins: [FN],
  data() {
    return {
        form:{
          oldPassword: '',
          password: '',
          password2: '',
        }
    }
  },
  computed: {
    rules() {
        const message = '輸入不完整'
        // 自訂驗證-password
        const isPassword = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(length < 8 || length > 14){
            callback(new Error('輸入錯誤，請輸入8-14位元'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password2
        const isNewPassword = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(value === this.form.oldPassword){
            callback(new Error('新舊密碼不可相同'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password2
        const isNewPassword2 = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(value !== this.form.password){
            callback(new Error('兩次輸入的密碼不同'))
          }else{
            callback()
          }
        }
        return {
            oldPassword: [
                { required: true, trigger: 'blur', validator: isPassword },
                { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
            ],
            password: [
                { required: true, trigger: 'blur', validator: isNewPassword },
                { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
            ],
            password2: [
                { required: true, trigger: 'blur', validator: isNewPassword2 },
                { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
            ]
        }
    },
    delayTimeText() {
      return this.delayText
    }
  },
  methods: {
    ...mapActions([
      'FETCH'
    ]),
    //送出表單
    handleSubmit() {
      const form = this.$refs.form
      this.beforeValidate()
      form.validate((valid) => {
          if (valid) {
              this.loading = true
              this.beforeFormSubmit()
              this.FETCH({
                key: 'CHANGE_PASSWORD',
                oldPassword: this.form.oldPassword,
                newPassword: this.form.password,
              })
                .then((this.handleResponse))
          } else {
              this.loading = false
              this.handleUnValid()
          }
      })

    },
    //回應
    handleResponse(res) {
      //避免殘留資訊先清空
      this.handleClearToken()
      if (!+res.code) {
        this.$confirm('密碼更改成功，請重新登入',{
          showCancelButton: false,
          type: 'success'
        })
          .then(() => {
            const { href } = this.$router.resolve({name: 'Login'})
            window.open(href, '_self')
          })
      }else{
        this.$confirm(res.message,{
          showCancelButton: false,
          type: 'error'
        })
      }
      this.loading = false
    },
    handleBack() {
      const { href } = this.$router.resolve({name: 'SetList'})
      window.open(href, '_self')
    }
  }
}
</script>
